/** @jsxImportSource @emotion/react */
import {
  FeedCard,
  Column,
  Text,
  TEXT_VARIANTS,
  ExternalLink,
  Tagline,
} from "../..";

export const VideoCard: React.FC = () => (
  <FeedCard path="/video/id">
    <Column gap={10}>
      <iframe
        width="100%"
        height="425"
        src="https://www.youtube.com/embed/2lBB-zsWnYE?controls=0"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      ></iframe>
      <Column crossAxisAlignment="start" gap={5}>
        <Text as="h3" variant={TEXT_VARIANTS.T30}>
          {
            "Humane: Secret Tech Company Poised to Change the World. Humane. What happens when 60 former Apple"
          }
        </Text>
        <Text as="p" variant={TEXT_VARIANTS.T20}>
          {
            "what if public libraries were open late every night and we could engage in public life there instead of having to choose between drinking at the bar and isolation"
          }
        </Text>
        <Tagline
          text="video · by $0"
          entities={[{ type: "person", name: "Gabriel Nessim Schloser" }]}
        />
        <ExternalLink>{"youtube.com"}</ExternalLink>
      </Column>
    </Column>
  </FeedCard>
);
